import { Card, Text } from '@gluestack-ui/themed'
import isEmpty from 'lodash/isEmpty'
import React, { FunctionComponent } from 'react'
import { StyleSheet } from 'react-native'
import { SignalementCommentResult } from '../../../api/Signalement/types'
import { i18n } from '../../../lib/i18n'
import { theme } from '../../../theme'
import { CardItem } from '../../NativeBaseLegacy'
import { SignalementComment } from './SignalementComment.component'

interface SignalementCommentListProps {
  comments: SignalementCommentResult[] | null
}

export const SignalementCommentList: FunctionComponent<SignalementCommentListProps> = ({ comments }) => {
  if (!comments || isEmpty(comments)) {
    return null
  }

  return (
    <Card p="$0" m="$1">
      <CardItem style={styles.cardItem}>
        <Text style={styles.title}>{i18n.t('signalement.comments')} :</Text>
      </CardItem>
      {comments.map(item => (
        <SignalementComment key={item.id} item={item} />
      ))}
      <CardItem />
    </Card>
  )
}

const styles = StyleSheet.create({
  title: {
    fontWeight: 'bold',
  },
  cardItem: {
    padding: theme.padding.x2,
  },
})
